export default __webpack_public_path__ + "static/suggest-7f0e2deaaab61bca73a0b7773b6f66bb.png";